import { FC, useEffect } from "react";

import Button from "components/Button/Button";
import { IDocument } from "config";
import { useTranslation } from "modules";
import { useAppDispatch, useAppSelector } from "store";
import { getDocumentsCategories } from "store/actions/documents";

import { find } from "lodash-es";

interface IProps {
  document?: IDocument;
}

export const BeneficiaryReviewClaimsLink: FC<IProps> = ({ document: documentProp }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const beneficiaryPacket = useAppSelector(state =>
    find(state.documents.documents, { slug: "beneficiary-packet" })
  );

  const document = documentProp || beneficiaryPacket;

  useEffect(() => {
    if (!document) {
      dispatch(getDocumentsCategories());
    }
  }, [document, dispatch]);

  const documentLink = document?.html?.url || document?.pdf?.url;
  if (!documentLink) {
    return null;
  }

  return (
    <a href={documentLink} target="_blank" rel="noreferrer">
      <Button
        type="button"
        text={t("beneficiary.main.claims_instructions", "Get Claims Instructions")}
        className="full-width beneficiary-overview__claims-instructions-button"
        icon="DocumentDownload"
        align="left"
        subtype="text-dark"
      />
    </a>
  );
};
